module.exports = __webpack_public_path__ + "img/weddings_1.41fbe2fa.jpg";